export const header = () => {
  const $header = document.querySelector("header.header");
  if ($header) {
    const $body = document.querySelector("body");

    const $localizationSelectors = $header.querySelectorAll(
      ".localization-selector"
    );
    $localizationSelectors.forEach(($localizationSelector) => {
      const $language = $localizationSelector.querySelector(
        ".localization-selector__langauge"
      );
      if ($language) {
        const $languageButton = $language.querySelector(".language__button");
        const $languageDropdown = $language.querySelector(
          ".language__dropdown"
        );
        const $languageForm =
          $languageDropdown.querySelector(".dropdown__form");
        const $formButtons = $languageForm.querySelectorAll(".form__button");
        const $formInput = $languageForm.querySelector(".form__input");

        $languageButton.addEventListener("click", (event) => {
          event.preventDefault();
          $languageDropdown.classList.remove("hidden");
        });

        $formButtons.forEach(($formButton) => {
          $formButton.addEventListener("click", (event) => {
            event.preventDefault();
            $formInput.value = $formButton.dataset.value;
            $languageForm.submit();
          });
        });

        $body.addEventListener("click", (event) => {
          if (
            event.target != $languageButton &&
            (event.target == $languageDropdown ||
              !$languageDropdown.contains(event.target))
          ) {
            $languageDropdown.classList.add("hidden");
          }
        });
      }

      const $location = $localizationSelector.querySelector(
        ".localization-selector__location"
      );
      if ($location) {
        const $locationButton = $location.querySelector(".location__button");
        const $locationDropdown = $location.querySelector(
          ".location__dropdown"
        );
        const $locationForm =
          $locationDropdown.querySelector(".dropdown__form");
        const $formButtons = $locationForm.querySelectorAll(".form__button");
        const $formInput = $locationForm.querySelector(".form__input");

        $locationButton.addEventListener("click", (event) => {
          event.preventDefault();
          $locationDropdown.classList.remove("hidden");
        });

        $formButtons.forEach(($formButton) => {
          $formButton.addEventListener("click", (event) => {
            event.preventDefault();
            $formInput.value = $formButton.dataset.value;
            $locationForm.submit();
          });
        });

        $body.addEventListener("click", (event) => {
          if (
            event.target != $locationButton &&
            (event.target == $locationDropdown ||
              !$locationDropdown.contains(event.target))
          ) {
            $locationDropdown.classList.add("hidden");
          }
        });
      }
    });

    const cart = window.Carbon.Cart;

    if (cart.useCartAside) {
      const $cartAsideBackground = document.querySelector(
        ".cart-aside__background"
      );
      const $cartAside = $cartAsideBackground.querySelector("aside.cart-aside");
      const $desktopCartLink = $header.querySelector(
        ".navbar__desktop .header__cart-link"
      );
      const $mobileCartLink = $header.querySelector(
        ".navbar__mobile .header__cart-link"
      );

      $desktopCartLink.addEventListener("click", (event) => {
        event.preventDefault();
        $body.classList.add("overflow-y-hidden");
        $cartAsideBackground.classList.remove("pointer-events-none");
        $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
        $cartAside.classList.remove(
          "translate-x-full",
          "ponter-events-none",
          "hidden"
        );
      });

      /*
        if ($mobileCartLink) {
          $mobileCartLink.addEventListener("click", (event) => {
            event.preventDefault();
            $body.classList.add("overflow-y-hidden");
            $cartAsideBackground.classList.remove("pointer-events-none");
            $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
            $cartAside.classList.remove(
              "translate-x-full",
              "ponter-events-none",
              "hidden"
            );
          });
        }
      }
  
  
      const $menuDesktop = $header.querySelector(".menu__desktop");
      const $menuDesktopShop = $header.querySelector(
        ".navbar__desktop .navbar__shop"
      );
  
      if ($menuDesktop && $menuDesktopShop) {
        $menuDesktopShop.addEventListener("mouseover", (event) => {
          event.preventDefault();
          $menuDesktop.classList.remove("opacity-0", "pointer-events-none");
          $menuDesktop.classList.add("opacity-100", "pointer-events-auto");
        });
  
        $menuDesktop.addEventListener("mouseover", (event) => {
          if (event.target == $menuDesktop) {
            $menuDesktop.classList.remove("opacity-100", "pointer-events-auto");
            $menuDesktop.classList.add("opacity-0", "pointer-events-none");
          }
        });
      }
  
      
      const $navbarMobile = $header.querySelector("nav.navbar .navbar__mobile");
      const $navbarMobileButton = $navbarMobile.querySelector(".navbar__button");
      const $menuMobile = $header.querySelector(".menu__mobile");
      const $menuMobileButton = $menuMobile.querySelector(".menu__button");
  
      const $menuMobileItems = $menuMobile.querySelectorAll(
        ".menu__items .menu__item"
      );
  
      $menuMobileItems.forEach(($menuMobileItem) => {
        const $itemButton = $menuMobileItem.querySelector(".item__button");
        const $itemItems = $menuMobileItem.querySelector(".item__items");
        $itemButton.addEventListener("click", (event) => {
          event.preventDefault();
          const $buttonIcon = $itemButton.querySelector(".button__icon");
          $buttonIcon.classList.toggle("rotate-180");
          $itemItems.classList.toggle("hidden");
        });
      });
  
      $navbarMobileButton.addEventListener("click", (event) => {
        event.preventDefault();
        $body.classList.add("overflow-y-hidden");
        $menuMobile.classList.remove("hidden");
        $menuMobile.classList.add("block");
      });
  
      $menuMobileButton.addEventListener("click", (event) => {
        event.preventDefault();
        $body.classList.remove("overflow-y-hidden");
        $menuMobile.classList.remove("block");
        $menuMobile.classList.add("hidden");
      });
      */
    }

    //Handle menu scroll toggling

    const announcementBar = $header.querySelector(".announcement-banner");
    const miniNav = $header.querySelector(".tribe-site-header__mini-nav");

    let lastScrollY = window.scrollY;

    window.addEventListener("scroll", () => {
      let currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        //hide the Announcement bar and mini nav
        if (announcementBar) {
          if (!announcementBar.classList.contains("hidden")) {
            announcementBar.classList.add("hidden");
          }
        }

        if (miniNav) {
          if (!miniNav.classList.contains("is-hidden")) {
            miniNav.classList.add("is-hidden");
          }
        }

        $body.classList.add("scrolled-down");
      } else if (currentScrollY < lastScrollY) {
        if (announcementBar) {
          if (announcementBar.classList.contains("hidden")) {
            announcementBar.classList.remove("hidden");
          }
        }

        if (miniNav) {
          if (miniNav.classList.contains("is-hidden")) {
            miniNav.classList.remove("is-hidden");
          }
        }
        $body.classList.remove("scrolled-down");
      }

      lastScrollY = currentScrollY;
    });

    //Mobile Menu events

    const $mobileIconsSection = $header.querySelector(
      ".tribe-site-header__actions--left"
    );
    const $mobileMenu = $header.querySelector(".tribe-mobile-menu");

    //Add this to the wrapper to stop the overflow issue, but we need to find out how to take it off properly too

    if ($mobileIconsSection && $mobileMenu) {
      const $mobileMenuWrapper = $mobileMenu.querySelector(
        ".tribe-mobile-menu__wrapper"
      );

      if ($mobileMenuWrapper) {
        const $menuToggleButton = $mobileIconsSection.querySelector(
          ".tribe-site-header__cta--menu-toggle"
        );
        if ($menuToggleButton) {
          $menuToggleButton.addEventListener("click", () => {
            //Close mobile menu and its contents
            if ($menuToggleButton.classList.contains("is-active")) {
              //swap icons
              $menuToggleButton.classList.remove("is-active");

              //Hide main window, during the animation find all active windows and remove the class, essentially starting the user again when they re-open
              const $activeWindows = $mobileMenu.querySelectorAll(".is-active");
              $mobileMenu.classList.remove("is-active");

              if ($activeWindows) {
                setTimeout(() => {
                  $activeWindows.forEach(($activeWindow) => {
                    $activeWindow.classList.remove("is-active");
                  });
                }, 400);
              }

              //Remove overflow restrictor from first level menu items
              $mobileMenuWrapper.classList.add(
                "tribe-mobile-menu__wrapper--overlay-showing"
              );

              //unlock background
              document.body.classList.remove("overflow-y-hidden");
            } else {
              //Open the menu and it's contents

              //swap icons
              $menuToggleButton.classList.add("is-active");

              //unhide announcement bar
              if (announcementBar) {
                if (announcementBar.classList.contains("hidden")) {
                  announcementBar.classList.remove("hidden");
                }
              }

              //Show menu contents
              $mobileMenu.classList.add("is-active");

              //Lock background to prevent double scrolling
              document.body.classList.add("overflow-y-hidden");
            }
          });

          const $topLevelMenuItems = $mobileMenu.querySelectorAll(
            ".tribe-mobile-menu__navlist-item > .tribe-mobile-menu__link--parent"
          );

          if ($topLevelMenuItems) {
            $topLevelMenuItems.forEach(($topLevelMenuItem) => {
              $topLevelMenuItem.addEventListener("click", () => {
                //make the child element visible
                $topLevelMenuItem.parentElement
                  .querySelector(".tribe-mobile-menu__child-navlist")
                  .classList.add("is-active");
                $mobileMenuWrapper.classList.add(
                  "tribe-mobile-menu__wrapper--overlay-showing"
                );
              });

              //Bind the Second level of menu items
              const $secondLevelMenuItems =
                $topLevelMenuItem.parentElement.querySelectorAll(
                  ":scope > .tribe-mobile-menu__child-navlist > .tribe-mobile-menu__child-navlist-item .tribe-mobile-menu__link--parent"
                );

              if ($secondLevelMenuItems) {
                $secondLevelMenuItems.forEach(($secondLevelMenuItem) => {
                  $secondLevelMenuItem.addEventListener("click", () => {
                    $secondLevelMenuItem.parentElement
                      .querySelector(".tribe-mobile-menu__child-navlist")
                      .classList.add("is-active");
                  });
                });
              }
            });

            //Bind All "back" buttons
            const $backButtons = $mobileMenu.querySelectorAll(
              ".tribe-mobile-menu__link--back"
            );
            if ($backButtons) {
              $backButtons.forEach(($backButton) => {
                $backButton.addEventListener("click", () => {
                  $backButton.parentElement.classList.remove("is-active");

                  //If this backbutton leads to the main mobile menu, remove the overflow restriction
                  if (
                    $backButton.parentElement.parentElement.parentElement.parentElement.classList.contains(
                      "tribe-mobile-menu__wrapper--overlay-showing"
                    )
                  ) {
                    $mobileMenuWrapper.classList.remove(
                      "tribe-mobile-menu__wrapper--overlay-showing"
                    );
                  }
                });
              });
            }
          }
        }
      }
    }
  }
};

export default header;
